import React from "react";
import { useSelector } from "react-redux";

const PipelineOverview = ({ pipelineStages, heading, label, customStyle }) => {
  const { role } = useSelector((state) => state.userReducer);
  console.log(pipelineStages, "lll");
  return role == "Admin" ? (
    <div className={`bg-white shadow-md rounded-lg p-4 ${customStyle}`}>
      <h2 className="text-lg font-semibold mb-4">{heading}</h2>

      <div className="mb-16">
        <div className="flex flex-row items-center justify-between mb-[10px]">
          <p>Total Paid Amount</p>
          <p className="text-sm flex flex-row">
            AED {pipelineStages?.totalPaidAmount?.amount}
            <p className="text-sm text-[gray] ml-[2px]">
              ({pipelineStages?.totalPaidAmount?.percentage}%)
            </p>
          </p>
        </div>

        <div className="bg-gray-200 rounded-full h-1 mb-2">
          <div
            className={`${
              pipelineStages?.totalPaidAmount?.percentage > 50
                ? "bg-blue-500"
                : pipelineStages?.totalPaidAmount?.percentage > 30
                ? "bg-green-500"
                : "bg-yellow-500"
            } h-1 rounded-full`}
            style={{ width: `${pipelineStages?.totalPaidAmount?.percentage}%` }}
          ></div>
        </div>
      </div>
      <div className="mb-16">
        <div className="flex flex-row items-center justify-between mb-[10px]">
          <p>Total Pending Amount</p>
          <p className="text-sm flex flex-row">
            AED {pipelineStages?.totalPendingAmount?.amount}
            <p className="text-sm text-[gray] ml-[2px]">
              ({pipelineStages?.totalPendingAmount?.percentage}%)
            </p>
          </p>
        </div>

        <div className="bg-gray-200 rounded-full h-1 mb-2">
          <div
            className={`${
              pipelineStages?.totalPendingAmount?.percentage > 50
                ? "bg-blue-500"
                : pipelineStages?.totalPendingAmount?.percentage > 30
                ? "bg-green-500"
                : "bg-yellow-500"
            } h-1 rounded-full`}
            style={{
              width: `${pipelineStages?.totalPendingAmount?.percentage}%`,
            }}
          ></div>
        </div>
      </div>
      <div className="mb-4">
        <div className="flex flex-row items-center justify-between mb-[10px]">
          <p>Total Over Due Amount</p>
          <p className="text-sm flex flex-row">
            AED {pipelineStages?.totalOverdueAmount?.amount}
            <p className="text-sm text-[gray] ml-[2px]">
              ({pipelineStages?.totalOverdueAmount?.percentage}%)
            </p>
          </p>
        </div>

        <div className="bg-gray-200 rounded-full h-1 mb-2">
          <div
            className={`${
              pipelineStages?.totalOverdueAmount?.percentage > 50
                ? "bg-blue-500"
                : pipelineStages?.totalOverdueAmount?.percentage > 30
                ? "bg-green-500"
                : "bg-yellow-500"
            } h-1 rounded-full`}
            style={{
              width: `${pipelineStages?.totalOverdueAmount?.percentage}%`,
            }}
          ></div>
        </div>
      </div>
    </div>
  ) : (
    <div className={`bg-white shadow-md rounded-lg p-4 ${customStyle}`}>
      <h2 className="text-lg font-semibold mb-4">{heading}</h2>
      {pipelineStages?.statusCounts?.length > 0 ? (
        pipelineStages?.statusCounts?.map((stage, index) => (
          <div key={index} className="mb-4">
            <div className="flex flex-row items-center justify-between mb-[10px]">
              <p>{stage?.label}</p>
              <p className="text-sm flex flex-row">
                {stage?.count} {label}{" "}
                <p className="text-sm text-[gray] ml-[2px]">
                  (
                  {(
                    (stage?.count / pipelineStages?.overview?.totalLeads) *
                    100
                  ).toFixed(2)}
                  %)
                </p>
              </p>
            </div>

            <div className="bg-gray-200 rounded-full h-1 mb-2">
              <div
                className={`${
                  (stage?.count / pipelineStages?.overview?.totalLeads) * 100 >
                  50
                    ? "bg-blue-500"
                    : stage?.percentage > 30
                    ? "bg-green-500"
                    : "bg-yellow-500"
                } h-1 rounded-full`}
                style={{
                  width: `${
                    (stage?.count / pipelineStages?.overview?.totalLeads) * 100
                  }%`,
                }}
              ></div>
            </div>
          </div>
        ))
      ) : (
        <tr className="">
          <td colSpan="7" className="text-center  text-gray-500 py-4">
            No pipeline found.
          </td>
        </tr>
      )}
    </div>
  );
};

export default PipelineOverview;
